const getTotal = (products, quantities) => {
    return Object.keys(quantities).map(productId => {
        const product = products.find(p => p.id == productId)
        if (!product) return {}
        const basePrice = product.pricing.find(p => p.quantity == quantities[productId].quantity)
        if (!basePrice) return {}
        
        // use addon price if applicable
        return quantities[productId].addon ? 
            basePrice.addons.find(a => a.id === quantities[productId].addon) :
            basePrice
        }).reduce((acc, val) => ({
        fees: acc.fees + (val.fees || 0),
        taxes: acc.taxes + (val.taxes || 0),
        total: acc.total + (val.total || 0),
        }), {fees:0, taxes:0, total:0});
}

export {
    getTotal
}